import React, { useRef, useCallback, useState } from 'react';
// import withAppInsights from '../.../appInsights.js';
// import { appInsights, reactPlugin } from '../../appInsights';
// import { withAITracking } from '@microsoft/applicationinsights-react-js';
import { contextStyles } from './contextStyles';
import cn from 'clsx';
import { useSelector } from 'react-redux';
import { getSelfAssertedProfiles, getOtherProfiles } from '../../store';
interface menuProps {
  data: any;
  close: any;
  position: any;
  type: 'nodeMenu' | 'edgeMenu' | 'paneMenu';
}

const getAttribute = (data: any, attribute: string) =>
  (data && data.hasOwnProperty('data') && data.data.hasOwnProperty(attribute) && data.data[attribute]) || '';

const ContextMenu = ({ data, close, position, type }: menuProps) => {
  const classes = contextStyles();
  const selfAssertedProfiles = useSelector(getSelfAssertedProfiles);
  const otherProfiles = useSelector(getOtherProfiles);

  const label = getAttribute(data, 'label');
  const subJourney = getAttribute(data, 'subJourney');

  return (
    <>
      {type === 'nodeMenu' && data['type'] !== 'decision' && (
        <div
          className={classes.contextMenu}
          style={{
            top: position.y - 45,
            left: position.x,
          }}
        >
          <ul className={classes.options}>
            <li className={cn(classes.header)}>{label}</li>
            {type === 'nodeMenu' && (
              <>
                {label != '' && (selfAssertedProfiles[label] || otherProfiles[label]) && (
                  <li
                    className={classes.active}
                    onClick={() => {
                      close({ action: 'edit', type: 'node', data: data });
                    }}
                  >
                    Edit Node
                  </li>
                )}
                {subJourney != '' && (
                  <li
                    className={classes.active}
                    onClick={() => {
                      close({ action: 'subJourney', type: 'node', data: data });
                    }}
                  >
                    Show SubJourneys
                  </li>
                )}
                {/*data &&
                  (!data.hasOwnProperty('type') || (data.hasOwnProperty('type') && data['type'] !== 'decision')) && (
                    <>
                      <li
                        className={classes.active}
                        onClick={() => {
                          close({ action: 'add-precondition', type: 'node', data: data });
                        }}
                      >
                        Add/Delete Precondition
                      </li>
                      <li
                        className={classes.active}
                        onClick={() => {
                          close({ action: 'add-technicalprofile', type: 'node', data: data, position: 'before' });
                        }}
                      >
                        Add Technical Profile Before
                      </li>
                      <li
                        className={classes.active}
                        onClick={() => {
                          close({ action: 'add-technicalprofile', type: 'node', data: data, position: 'after' });
                        }}
                      >
                        Add Technical Profile After
                      </li>
                    </>
                      )*/}
                {/* <li
              className={classes.active}
              onClick={() => {
                close({ action: 'edit', type: 'node', data: data });
              }}
            >
              Delete Node
            </li> */}

                {/* <li className={cn(classes.subHeader)}>Smart Action</li> */}
                {/* <li
              className={cn(classes.active)}
              onClick={() => {
                close({ action: 'smartAction-OTP', type: 'node', data: data });
              }}
            >
              OTP
            </li> */}
              </>
            )}
          </ul>
        </div>
      )}
      {type === 'edgeMenu' && (
        <>
          <li
            onClick={() => {
              close({ action: 'edit', type: 'edge', data: data });
            }}
          >
            Edit Edge
          </li>
        </>
      )}
      {type === 'paneMenu' && (
        <>
          <li
            onClick={() => {
              close({ action: 'add', type: 'pane', data: data });
            }}
          >
            Add Node
          </li>
        </>
      )}
    </>
  );
};

//@ts-ignore
// export default withAITracking(reactPlugin, ContextMenu);
export default ContextMenu;
